// extracted by mini-css-extract-plugin
var _1 = "XVPABnKQm4mpTbIAOtro";
export { _1 as "heading" }
